import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';
import { CliSqliteInterrupted } from '../../sqlite/code-nav-cache/database.js';

export function assertFileIndexPersistNotShutdown(): void {
  if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
}
